import { IDictionary } from "@/shared/models/interface/dictionary-model"
import { IPureSearchIndex, IResearcher, Locale, IInfo, IStaffOrganisationAssociation } from "../models/pure-search-index-model"
import { SearchResult } from "../models/search-result-model"
import { AzureSearchMapper } from "./base-search-response-mapper"

export class PureResultsMapper extends AzureSearchMapper<IPureSearchIndex> {
    private language: Locale = Locale.EN
    private labels: IDictionary<string> = {}

    constructor(language: Locale, labels: IDictionary<string> = {}) {
        super()

        this.language = language
        this.labels = labels
    }

    public mapResult(item: IPureSearchIndex): SearchResult {
        // Hardcoded language as EN because there is no NL data available
        let info: IInfo = this.getLocaleInfo(item.Model.Info, Locale.EN)
        let title: string = this.mapTitle(item.Model, info)

        // Use current language to get a language based url
        let url: string = this.getDetailPageUrl(item.Model.Info, this.language)

        return new SearchResult(
            item.Model.PureId,
            url,
            title,
            "",
            this.mapBodyText(info),
            this.mapImage(item.Model.ProfilePhoto, title),
            ["Pure"],
            [], // Tags
        )
    }

    private getDetailPageUrl(info: IInfo[], language: Locale) {
        let infoObject: IInfo = this.getLocaleInfo(info, language)
        return infoObject.DetailPageUrl
    }

    private getLocaleInfo(info: IInfo[], language: Locale) {
        return info.find(x => x.Language == language) ?? info[0]
    }

    private mapTitle(item: IResearcher, info: IInfo): string {
        return `${info.Prenominal ?? ""} ${item.KnownAs ? item.KnownAs : item.Name}${info.Postnominal ? `, ${info.Postnominal}` : ""}`.trim()
    }

    private mapBodyText(info: IInfo): string[] {
        let bodyText: string[] = []

        if (info.StaffOrganisationAssociations) {
            bodyText.push(...this.mapJobs(info.StaffOrganisationAssociations))
        }

        return bodyText
    }

    private mapJobs(associations: IStaffOrganisationAssociation[]): string[] {
        return associations.map((association: IStaffOrganisationAssociation) => {
            var jobTitle = association.JobTitle ? `<span class="vuw-bold">${association.JobTitle} -</span>` : ''
            return `${jobTitle ?? ''} ${association.OrganisationalUnitNames.join(", ")}`.trim()
        })
    }
}